export const defaultToolbarItems = {
  items: [
    'customUndo',
    'customRedo',
    '|',
    'customSourceEditing',
    '|',
    'heading',
    'customFontSize',
    '|',
    'customFontColor',
    'customBold',
    'customItalic',
    'customUnderline',
    'customStrikethrough',
    '|',
    'alignment',
    'customNumberedList',
    'customBulletedList',
    'customLink',
    'customTable'
  ],
  shouldNotGroupWhenFull: false,
}

export const defaultFontSizeOptions = {
  options: [ 8, 9, 10, 11, 12, 14, 18, 24, 26, 28, 30, 36, 48, 72 ],
  supportAllValues: true,
  defaultValue: 14,
}

export const defaultHeadingOptions = {
  options: [
    {
      model: 'heading1',
      view: 'h1',
      title: 'Título 1',
      class: 'ck-heading_h1'
    },
    {
      model: 'heading2',
      view: 'h2',
      title: 'Título 2',
      class: 'ck-heading_h2'
    },
    {
      model: 'paragraph',
      title: 'Texto',
      class: 'ck-heading_paragraph'
    },
  ]
}

export const defaultHtmlSupport = {
  allow: [
    {
      name: [
        'p',
        'strong',
        'em',
        'u',
        's',
        'a',
        'ul',
        'ol',
        'li',
        'span',
        'div',
        'h1',
        'h2',
        'h3',
        'h4',
        'table',
        'thead',
        'tbody',
        'tr',
        'th',
        'td',
        'img',
      ],
      styles: {
        'font-size': true,
        'color': true,
        'text-align': true
      },
      attributes: {
        'src': true,
        'alt': true,
        'href': true,
        'target': true,
        'download': true,
        'style': true,
        'border': true
      },
      classes: false
    }
  ],
  disallow: [
    {
      name: /^(script|iframe|object|embed|form|input|button|style|link)$/
    }
  ]
}

export const defaultLinkConfig = {
  addTargetToExternalLinks: true,
  defaultProtocol: 'https://',
  decorators: {
    toggleDownloadable: {
      mode: 'manual',
      label: 'Downloadable',
      attributes: {
        download: 'file',
      },
    },
  },
}

export const defaultListConfig = {
  properties: {
    styles: true,
    startIndex: true,
    reversed: true,
  },
}
